import React from 'react';
import Boutons from './Boutons';

const Resultat = ( { tranche, callback } ) => {

    return (
        <div>
            <h2>Estimation de ma participation financière :</h2>
            <br/>
            <div className="resultat">
                { tranche && (
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            Le prix de l'ordinateur Ordi'Lot a été négocié à <strong>560 €</strong>.
                        </div>
                        <br/>
                        <div className="participation" style={{marginLeft:"30px"}}>
                            <div className="col-sm-12 col-md-12" style={{fontSize:"1.5em"}}>
                                Ma participation estimée : <strong>{tranche.montantFamille} €</strong>
                            </div>
                            <div className="col-sm-12 col-md-12">
                            (Pour cette participation, l'aide du Département correspond à <strong>{tranche.montantDepartement} €</strong>)
                            </div>
                        </div>
                    </div>
                )}
                <br/>
                <small><i>Attention, les montants affichés sont indicatifs et devront être validés par nos services lors de l'instruction de votre dossier.</i></small>
                <Boutons retour="initial" callback={callback}/>
            </div>
        </div>
    );
}

export default Resultat;
